export { default } from './Pluralize'
export * from './Pluralize'
